export enum DeviceNetworkType {
  LORA = "LORA",
  MQTT = "MQTT",
}
